const state = {
    citiesList: [],
    citiesList4: []
}

const mutations = {
    'SET_CITIESLIST' (state, citiesList) {
        state.citiesList = citiesList
    },
    'SET_CITIESLIST4' (state, citiesList4) {
        state.citiesList4 = citiesList4
    },
}

const actions = {
  setCitiesLists ({ commit }, { citiesList, citiesList4 }) {
    commit('SET_CITIESLIST', citiesList);
    commit('SET_CITIESLIST4', citiesList4);
  }
};

const getters = {
  getCitiesList: (state) => state.citiesList,
  getCitiesList4: (state) => state.citiesList4
};

export default {
    state,
    mutations,
    actions,
    getters
}
